<template>
  <router-view></router-view>
</template>

<script>
export default {
	name: 'Questoes',
	title: 'Questões'
}
</script>

<style scoped>
</style>
